import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
import permission from './modules/permission'
import user from './modules/user'
import message from './modules/message'
import getters from './getters'
import theme from './modules/theme'
// import systemstyle from './modules/systemstyle'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        permission,
        theme,
        user,
        message
    },
    getters
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js